<h2 mat-dialog-title>{{so_id? 'Update Stall' : 'Add Stall'}}</h2>
<form [formGroup]="StallForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content class="content">


        <!-- <div class="column mb-3"> -->
        <div class="row mb-4">
            <div class="col-9">
                <mat-label>Select Image</mat-label>
                <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                </div>
            </div>

            <div class="col-3">
                <div *ngIf="!isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall/{{this.imagePath}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
                <div *ngIf="isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall/{{image_name}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
            </div>


        </div>
        <!-- </div> -->

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Stall Number</mat-label>
                <input [ngModel]="stall_num" formControlName="stall_num" matInput placeholder="Enter Owner Name"
                    readonly="true">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Owner Name</mat-label>
                <input [ngModel]="owner_name" formControlName="owner_name" matInput placeholder="Enter Owner Name"
                    readonly="true">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Owner Number</mat-label>
                <input [ngModel]="owner_number" formControlName="owner_number" type="number" maxlength="10" matInput
                    placeholder="Enter Owner Number" readonly="true">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Company Name</mat-label>
                <input [ngModel]="company_name" formControlName="company_name" matInput
                    placeholder="Enter Company name">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Website</mat-label>
                <input [ngModel]="website" formControlName="website" matInput placeholder="Enter Website">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Youtube</mat-label>
                <input [ngModel]="youtube" formControlName="youtube" matInput placeholder="Enter Youtube">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Facebook</mat-label>
                <input [ngModel]="facebook" formControlName="facebook" matInput placeholder="Enter Facebook">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Instagram</mat-label>
                <input [ngModel]="instagram" formControlName="instagram" matInput placeholder="Enter Instagram">
            </mat-form-field>
        </div>

        <div class="column">
            <mat-form-field appearance="outline">
                <mat-label>Notes</mat-label>
                <input [ngModel]="notes" formControlName="notes" matInput placeholder="Enter Notes...">
            </mat-form-field>
        </div>

    </mat-dialog-content>
    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button type="submit" color="primary">{{so_id? 'Update' : 'Add'}}</button>
    </mat-dialog-actions>
</form>